import { useSuspenseQuery } from '@apollo/client';
import noop from 'lodash/noop';

import {
  getTenantUserSettingsQuery,
  useTenantUserSettings,
} from '@eluve/frontend-feature-user-settings';
import {
  DEFAULT_UI_LANGUAGE,
  I18nProvider,
  isUiLanguageCode,
} from '@eluve/i18n';
import {
  useAssignedTenantIdFromParams,
  useUserIdFromSession,
} from '@eluve/session-helpers';

export const TenantUserSettings: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const tenantId = useAssignedTenantIdFromParams();
  const userId = useUserIdFromSession();
  useSuspenseQuery(getTenantUserSettingsQuery, {
    variables: { tenantId, userId },
  });

  const { settings } = useTenantUserSettings();
  const serverLanguage = settings?.uiLanguageOrDefault;
  const language = isUiLanguageCode(serverLanguage)
    ? serverLanguage
    : DEFAULT_UI_LANGUAGE;

  // Derived-only for now: web has no user-facing language switcher, so the
  // provider just mirrors the tenant/user setting.
  return (
    <I18nProvider language={language} setLanguage={noop}>
      {children}
    </I18nProvider>
  );
};
